import './App.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Header from './Component/Header/Header.js';
import Footer from './Component/Footer/Footer.js';

import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';

import Home from './Pages/Home/Home';
import Blog from './Pages/Blog/Blog';
import Faq from './Pages/Faq/Faq';
import Contact from './Pages/Contact/Contact';
import Masonry from './Pages/Masonry/Masonry';
import Pricing from './Pages/Pricing/Pricing';
import OurService from './Pages/OurService/OurService';
import Works from './Pages/Works/Works';
import About from './Pages/About/About';

function App() {
  return (
    <div>
      <Router>
        <Header />
        <Routes>
          <Route path='/' exact element={<Home />} />
          <Route path='/Blog' element={<Blog />} />
          <Route path='/Faq' element={<Faq />} />
          <Route path='/Contact' element={<Contact />} />
          <Route path='/Masonry' element={<Masonry />} />
          <Route path='/Pricing' element={<Pricing />} />
          <Route path='/OurService' element={<OurService />} />
          <Route path='/Works' element={<Works />} />
          <Route path='/About' element={<About />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;